module.exports = __webpack_public_path__ + "static/media/mybrandblk.2887e689.svg";